import styled from "styled-components";
import media from "constants/media";

export const RadioStyled = styled.label`
    position: relative;

    display: flex;
    align-items: flex-start;

    width: 100%;

    margin: 5px 0 20px;

    border-radius: 4px;
`;

export const Content = styled.div`
    display: flex;

    cursor: pointer;
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    min-width: 20px;
    height: 20px;

    border: 1px solid var(--color-peach);
    border-radius: 50%;

    transition: 0.2s all ease-in-out;
`;

export const Fill = styled.div`
    width: 12px;
    height: 12px;

    background: var(--color-peach);
    border-radius: 50%;

    visibility: hidden;
    opacity: 0;

    transition: 0.2s all ease-in-out;

    &.preload {
        transition: 0s all;
    }
`;

export const Text = styled.div`
    margin: -2px 0 0 10px;

    font-size: 14px;
    line-height: 20px;

    img,
    svg {
        height: 14px;
        margin-right: 8px;
    }

    a {
        font-size: 14px;
    }

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;

        a {
            font-size: 15px;
        }
    `}
`;

export const Input = styled.input`
    display: none;

    &:active + ${Content} {
        ${Circle} {
            box-shadow: var(--color-peach) 0 1px 4px 0 inset;
        }
    }

    &:hover + ${Content} {
        ${Circle} {
            border-color: var(--color-darkNight);
        }
    }

    &:checked + ${Content} {
        ${Fill} {
            visibility: visible;
            opacity: 1;
        }
    }

    &:disabled + ${Content} {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
